/* eslint-disable react/forbid-elements */

import PropTypes from 'prop-types';

import CmsBlock from 'Component/CmsBlock';
import ContentWrapper from 'Component/ContentWrapper';
import { FACEBOOK, INSTAGRAM, NEWSLETTER_COLUMN, PINTEREST, TWITTER } from 'Component/Footer/Footer.config';
import Icons from 'Component/Icons';
import { Footer as SourceFooter } from 'SourceComponent/Footer/Footer.component';

import LogoSmall from '../../assets/images/logo-S.png';

/** @namespace Advox/Component/Footer/Component */
export class Footer extends SourceFooter {
    static propTypes = {
        ...SourceFooter.propTypes,
        postcode: PropTypes.string,
        city: PropTypes.string,
        street_line1: PropTypes.string,
        street_line2: PropTypes.string,
        phone: PropTypes.string,
        email: PropTypes.string,
        scrollTop: PropTypes.func,
    };

    static defaultProps = {
        ...SourceFooter.defaultProps,
        isVisibleOnMobile: true,
        postcode: '',
        city: '',
        street_line1: '',
        street_line2: '',
        phone: '',
        email: '',
        scrollTop: () => {},
    };

    shouldComponentUpdate(nextProps) {
        const {
            device: { isMobile, isTablet },
            isVisibleOnMobile,
            copyright,
            newsletterActive,
        } = this.props;

        const {
            device: { isMobile: nextIsMobile, isTablet: nextIsTablet },
            isVisibleOnMobile: nextIsVisibleOnMobile,
            copyright: nextCopyright,
            newsletterActive: nextNewsletterActive,
        } = nextProps;

        return (
            isMobile !== nextIsMobile ||
            isTablet !== nextIsTablet ||
            isVisibleOnMobile !== nextIsVisibleOnMobile ||
            copyright !== nextCopyright ||
            newsletterActive !== nextNewsletterActive
        );
    }

    renderColumn = (column, i) => {
        const { title, subtitle, columnActiveKey, items, isItemsHorizontal, mods = {} } = column;
        const contentMods = isItemsHorizontal ? { direction: 'horizontal' } : {};
        const { [columnActiveKey]: isColumnActive } = this.props;

        if (columnActiveKey && !isColumnActive === true) {
            return null;
        }

        return (
            <div block="Footer" elem="Column" mods={mods} key={i}>
                <h2 block="Footer" elem="ColumnTitle">
                    {title}
                </h2>
                <div block="Footer" elem="ColumnSubtitle">
                    {subtitle}
                </div>
                <div block="Footer" elem="ColumnContent" mods={contentMods}>
                    {items.map(this.renderColumnItem.bind(this))}
                </div>
            </div>
        );
    };

    renderCmsBlockWrapper() {
        const { footer_content: { footer_cms } = {} } = window.contentConfiguration;
        const {
            device: { isMobile, isTablet },
        } = this.props;

        return (
            <div block="Footer" elem="Content">
                <div block="Footer" elem="Columns" mix={{ block: 'ContentWrapper' }}>
                    {this.renderColumn({
                        ...NEWSLETTER_COLUMN,
                        mods: { isNewsletter: true },
                    })}
                    {(isMobile || isTablet) && this.renderContact()}
                    <CmsBlock identifier={footer_cms || 'footer_links'} blockType="footerLinks" />
                </div>
            </div>
        );
    }

    renderContact() {
        const { postcode, city, street_line1, street_line2, phone, email } = this.props;

        return (
            <div block="Footer" elem="ContactWrapper">
                <div block="Footer" elem="Contact">
                    <span block="Footer" elem="Logo">
                        <img src={LogoSmall} alt="Logo" width="55px" height="51px" />
                    </span>
                    <div block="Footer" elem="ContactItems">
                        <div block="Footer" elem="ContactItem">
                            <Icons name="pin" />
                            {street_line1}
                            <br />
                            {street_line2 && (
                                <>
                                    street_line2
                                    <br />
                                </>
                            )}
                            {`${postcode} ${city}`}
                        </div>
                        <div block="Footer" elem="ContactItem">
                            <Icons name="phone" />
                            <a href={`tel:${phone}`}>{phone}</a>
                        </div>
                        <div block="Footer" elem="ContactItem">
                            <Icons name="envelop" />
                            <a href={`mailto:${email}`}>{email}</a>
                        </div>
                    </div>
                </div>
                {this.renderSocial()}
            </div>
        );
    }

    renderSocial() {
        const {
            device: { isMobile },
        } = this.props;

        return (
            <div block="Footer" elem="SocialWrapper">
                {!isMobile && (
                    <span block="Footer" elem="SocialHeader">
                        {__('Social media')}
                    </span>
                )}
                <div block="Footer" elem="Social">
                    <a href={FACEBOOK} target="_blank" rel="noreferrer">
                        <Icons name="facebook" fill="#A1A1A1" />
                    </a>
                    <a href={TWITTER} target="_blank" rel="noreferrer">
                        <Icons name="twitter" fill="#A1A1A1" mix={{ block: 'Footer', elem: 'Twitter' }} />
                    </a>
                    <a href={PINTEREST} target="_blank" rel="noreferrer">
                        <Icons name="pinterest" fill="#A1A1A1" />
                    </a>
                    <a href={INSTAGRAM} target="_blank" rel="noreferrer">
                        <Icons name="instagram" fill="#A1A1A1" />
                    </a>
                </div>
            </div>
        );
    }

    renderCopyrightContent() {
        const { copyright } = this.props;

        return (
            <ContentWrapper label="">
                <div block="Footer" elem="CopyrightContent">
                    <span block="Footer" elem="Copyright">
                        {copyright}
                    </span>
                    <span block="Footer" elem="PoweredBy">
                        {__('by advox')}
                    </span>
                </div>
            </ContentWrapper>
        );
    }

    renderContent() {
        const {
            device: { isMobile, isTablet },
        } = this.props;

        return (
            <div block="Footer" elem="Container">
                {this.renderCmsBlockWrapper()}
                {!isMobile && !isTablet && <ContentWrapper label="">{this.renderContact()}</ContentWrapper>}
            </div>
        );
    }

    renderScrollTop() {
        const { scrollTop } = this.props;

        return (
            <ContentWrapper mix={{ block: 'Footer', elem: 'ScrollTopWrapper' }} label="">
                <button block="Footer" elem="ScrollTop" onClick={scrollTop}>
                    <Icons name="arrow_up" fill="#fff" />
                </button>
            </ContentWrapper>
        );
    }

    render() {
        return (
            <footer block="Footer" aria-label="Footer">
                {this.renderContent()}
                {this.renderScrollTop()}
                {this.renderCopyrightContent()}
            </footer>
        );
    }
}

export default Footer;
